<template>
  <Editor
    :editorStyle="'height: '+height+'px'"
    :pt="{
      root: {
        class: 'border rounded-md border-gray-500/20 dark:border-white/20 hover:border-theme/50',
        transitionClass
      },
      content: {
        class: 'input-editor-content'
      },
      toolbar: {
        class: 'input-editor-toolbar'
      },
      option: {
        class: '!hidden'
      },
      header: {
        class: '!hidden'
      },
      color: {
        class: '!hidden'
      },
      background: {
        class: '!hidden'
      },
      list: {
        class: '!hidden'
      },
      select: {
        class: '!hidden'
      },
      link: {
        class: '!hidden'
      },
      image: {
        class: '!hidden'
      },
      codeBlock: {
        class: '!hidden'
      },
      clean: {
        class: '!hidden'
      },
    }"
  ></Editor>

</template>

<script>

import Editor from 'primevue/editor';

export default {
  name: "RpmEditorInput",
  components: {
    Editor
  },
  props: {
    height: {
      type: [String, Number],
      default: '100'
    },
    placeHolderClass: {
      type: [String, Array, Object],
      default: ''
    },
    focusFocusClass: {
      type: [String, Array, Object],
      default: ''
    },
    transitionClass: {
      type: [String, Array, Object],
      default: ''
    },
    paddingClass: {
      type: [String, Array, Object],
      default: ''
    },
    borderClass: {
      type: [String, Array, Object],
      default: ''
    },
    focusClass: {
      type: [String, Array, Object],
      default: ''
    },
    panelClass: {
      type: [String, Array, Object],
      default: ''
    },
    textClass: {
      type: [String, Array, Object],
      default: ''
    },
  },
  methods: {}
};

</script>
